/**
 * Cross Sell performance tracking component.
 *
 * @module app/components/crossSell/CrossSellPerformanceTracking
 */
import jQuery from 'jquery';
import UrlQueryStringProvider from '../UrlQueryStringProvider';

/**
 * Returns an object containing the params required for game performance tracking
 *
 * @param {object} gameObj
 * @returns {{position, location, funnel, language: (string|*), page: (string|string), tab: string}}
 */
var getTrackingParams = function getTrackingParams(gameObj) {

    return {
        position: gameObj.position,
        location: gameObj.location,
        funnel: gameObj.funnel,
        language: window.WH.sportsbook.lang,
        page: window.WH.sportsbook.sportEn,
        tab: 'sports',
    };

};

/**
 * Returns an object containing the original url params,
 * combined with extra tracking params required for games performance tracking.
 * It retains any params set in the original url rather than overwriting
 *
 * @param originalParams
 * @param {object} gameObj
 */
var decorateURLParams = function decorateURLParams(originalParams, gameObj) { // jshint ignore: line

    var originalParamsObj = (originalParams) ? UrlQueryStringProvider.getQueryParams(originalParams) : {};

    return jQuery.extend(getTrackingParams(gameObj), originalParamsObj);


};

/**
 * Checks whether this is a game url which
 * should have the additional params added
 *
 * @param {string} url
 * @returns {boolean}
 */
var isGameLauncherURL = function isGameLauncherURL(url) {

    return url.indexOf('/launch/') !== -1;
};

/**
 * Adds extra tracking params to url.
 *
 * @param {string} url
 * @param {object} gameObj
 *
 * @returns {string}
 */
var appendURLParams = function appendURLParams(url, gameObj) {

    if (isGameLauncherURL(url)) {

        var currentUrlSections = url.split('?');
        var originalParams = currentUrlSections[1];
        var extendedUrlParams = decorateURLParams(originalParams, gameObj);
        var paramsString = jQuery.param(extendedUrlParams);

        url = currentUrlSections[0] + '?' + paramsString;
    }

    return url;
};

/**
 * Contains functions exposed by this component as an API.
 *
 * @type {Object}
 *
 * @public
 */
export default {

    appendURLParams: appendURLParams,

};
